<template>
  <div>
    <div v-if="stores.length > 0" :class="$style.shop_table_list">
      <div v-if="isMd" :class="$style.list_head">
        <div>全 {{ allCount }} 店舗中 {{ listCount }}店舗 を表示</div>
      </div>
      <div v-for="store in stores" :key="store.document_id" :class="$style.content">
        <StoreTableListItem :store="store" />
      </div>

      <div :class="$style.pager_area">
        <MoleculesConsumerPager
          :total-page="totalPageCount"
          :current-page="currentPage"
          :update-page-mode="'emit'"
          @update-page="updateFilterValue"
        />
      </div>
    </div>
    <div v-else>
      <div :class="$style.no_result">
        お探しの条件に該当する店舗が見つかりませんでした。<br />お手数ですが他の条件でお試しください。
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StoreFragment } from "~/types/type.generated"

defineProps<{
  stores: StoreFragment[]
  totalPageCount: number
  currentPage: number
  allCount: number
  listCount: number
  isMd: boolean
}>()

const route = useRoute()

const createFilterQuery = (page: number) => {
  const query: { [key: string]: string } = { page: "1" }
  if (page) query.page = page.toString()
  if (typeof route.query.products === "string") query.products = route.query.products
  if (typeof route.query.type === "string") query.type = route.query.type
  if (typeof route.query.scale === "string") query.scale = route.query.scale
  if (typeof route.query.otherSelect === "string") query.otherSelect = route.query.otherSelect
  if (typeof route.query.prefecture === "string") query.prefecture = route.query.prefecture
  if (typeof route.query.searchText === "string") query.searchText = route.query.searchText
  if (typeof route.query.latitude === "string") query.latitude = route.query.latitude
  if (typeof route.query.longitude === "string") query.longitude = route.query.longitude
  return query
}

const updateFilterValue = (page: number) => {
  const query = createFilterQuery(page)
  navigateTo({ query })
}
</script>

<style lang="scss" scoped module>
.shop_table_list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 40px;
  border: none;
  @include md {
    flex-flow: column;
  }
  .list_head {
    padding: 1rem 0;
    border-top: 1px solid $primary-20;
    border-bottom: 1px solid $primary-20;
  }
  .content {
    width: 100%;
  }
  .pager_area {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
.no_result {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
